<div class='AccountListing container-fluid py-3'>
  <h3>Account Listing</h3>
  <app-table
    *ngIf='tableReady$ | async'
    [columns]='tableColumns'
    [dataSourceParams]='tableDataSourceParams'
    [dataSource]='dataSource'
    [filterGroups]='tableFilterGroups'
    [massiveActions]='tableMassiveActions'
    [rowClass]='getRowColor'
    [selectable]='true'
    [selectable]='false'></app-table>
</div>
